export default __webpack_public_path__ + "static/media/no-active-agency.aa0a43cb.svg";